import React from "react";
import { Container } from "react-bootstrap";

const Disclaimer = () => {
  return (
    <Container className="my-4">
      <p className="">
        <span className="fw-bold">Disclaimer</span> We hope you benefit from the partners we recommend. They were each selected and vetted by industry experts.
        In the spirit of reciprocity and cooperation, in exchange for providing exclusive discounts for our members, the Cooperative collects a share of sales
        and/or other compensation for any purchase using any of the links on this page. We hope you find the exclusive discounts helpful.
      </p>
    </Container>
  );
};

export default Disclaimer;
